import { GlobalContext } from '../../../../../../../utils/globalprovider.js';
import TextToolbar from './texttoolbar.js';
import { getLisibility, getSubtitleErrorsInfos } from '../../../../../../../utils/checksubtitles.js';

import Tooltip from '../../../../../../../components/bases/tooltips/tooltip.js';
import Icon from '../../../../../../../components/bases/icone/icon.js';

import SimpleButton from './simplebutton.js';

import React from 'react';
import './subtitle.css';

import { drawMixin } from '../../actions/draw.js';
import { first, isEqual, join, reverse } from 'lodash';

import imgUpWord from "./assets/upword.png"
import imgDownWord from "./assets/downword.png"

import {
  onMoveCursorLetterByLetter,
  onMoveCursorToLeft,
  onMoveCursorToRight,
  onMoveCursorToDown,
  onMoveCursorToUp,
  onMoveWordByWord,  
  onGoToStartOrEndOfSubtitle,
  onGoToStartOrEndOfLigne,
  onGoToStartOrEndOfWord,
} from '../../../common/actions/cursor.js';

import {
  onSetDialog,
  onMoveSubtitle,
  onMoveSubtitleToLeft,
  onMoveSubtitleToRight,
  onMoveSubtitleToDown,
  onMoveSubtitleToUp,
  onMoveSubtitleTo,
  onMoveLineToDown,
  onMoveLineToUp,
  onRotateWord,
  onRotateWordToUp,
  onRotateWordToDown,
} from '../../../common/actions/move.js';

import {
  onDoubleClick,
  onMouseMove,
  onMouseUp,
  onMouseDown,
  onClick
} from '../../actions/mouse.js';

import {
  addChar,
  addHebrewOrArabicChar,
} from '../../actions/char.js';

import { 
  addCommonChar, 
  addCommonHebrewOrArabicChar,
  addSpace,
  addHyphen,
  onReturnToLineWithHypen,
  addPeriod,
  removeUnsecableSpace,
  groupWordsByUnsecableSpace,
  groupWordsWithoutSpace,
  onConversionToInitial,
  onUpperOrLowerCase,
  addQuotes,
  addApostrophes,
  addOrRemoveLetter,
  invertPeriodAndComma,
  invertALetter,
  hyphenateTwoWords,
  replaceHyphenate,
  addOrRemoveLetterWithApostrophe,
  addOrRemoveApostropheToLetter,
  replaceLetter,
  addOrRemoveLeToWord,
} from '../../../common/actions/char.js';

import {
  onTakeWordToSubtitle,
  onTakeWordFromLastSubtitleToCurrentSubtitle,
  onTakeWordFromNextSubtitleToCurrentSubtitle,
  onTakeWordFromCurrentSubtitleToPrevSubtitle,
  onTakeWordFromCurrentSubtitleToNextSubtitle,
  onCutSubtitle,
  onRegroupSubtitle,
  onMoveWordToPreviousSubtitle,
  onMoveWordToNextSubtitle,
  onMoveWordToPreviousLine,
  onMoveWordToNextLine,
} from '../../actions/keyboard.js';

import {
  onBackspace,
  onBackspaceLeftToRight,
  onSetColor,
  onSelect,
  onSelectLeftOrRight,
  onSelectTopOrBottom,
  onSelectUpOrDownSentence,
  onSelectLetterByLetter,
  onDelete,
  onDeleteLeftToRight,
  onDeleteWord,
  onDeleteWordsUntil,
  onDeleteLine,
  onDeleteSelection,
  onEnter,
  onSelectWithCtrlA,
  onMarkWord,
  onCopy,
  onCut,
  onPaste,
  onTab,
  onChangeLineHeight,
} from '../../../common/actions/keyboard.js'

import { 
  addNewActionForUndo,
  updateSubtitleAfterUndoOrRedo,
  addSubtitlesToUndoOrRedo,
  cancelUndo, 
  onUndoOrRedo } from '../../../common/actions/undo-redo.js';

import {
  onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle,
  onTakeTimeCodeToSubtitle,
  onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle,
  onTakeTimeCodeFromNextSubtitleToCurrentSubtitle,
} from '../../actions/timecode.js';

import {
  onApplyCorrection,
  onApplyCorrectionAll,
  onApplyCorrectionForSpelling,
  onApplyCorrectionForSpellingEnglish,
  onApplyCorrectionForGrammar,
  onCloseContextMenu,
  onShowContextMenu,
  onAddWordToDictionary,
  onIgnoreWordForCorrection,
  onIgnoreSuggestForCorrection,
} from '../../actions/corrector.js';

import { functionsMixin } from '../../../common/mixin.js';
import Lisibility from '../../../../lisibility/lisibility.js';
import ContextMenu from '../context-menu/context-menu.js';
import { getColorByShortcut } from '../../../../../../../utils/colors.js';
import { onCloseSpeakerMenu, onOpenSpeakerMenu, onSelectSpeaker } from '../../actions/speaker.js';
import SpeakerMenu from '../speaker-menu/speaker-menu.js';
import { cloneSubtitle, replaceWordsWithDifferentCount } from '../../../common/functions.js';
import SelectionCheckbox from '../selection-checkbox/selection-checkbox.js';


class Subtitle extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    Object.assign(this, drawMixin);
    Object.assign(this, functionsMixin);

    this.lisibilityRef = React.createRef();

    this.state = {
      active: false,
      focus: false,
      contextMenu: {
        display: false,
        x: 0,
        y: 0,
        word: null,
      },
      speakerMenu: {
        display: false,
        x: null,
        y: null,
        speakerId: null,
        indexLine: null
      },
    };

    this.rafId = 0;
    this.rafPending = false;

    // refs
    this.contextMenuRef = React.createRef();
    this.speakerMenuRef = React.createRef();

    // Canvas
    this.backCanvas = document.createElement('canvas'); // canvas arrière plan
    this.foreCanvas = React.createRef(); // référence vers de canvas affiché
    this.foreCtx = null;
    this.backCtx = null;
    this.width = 0;
    this.height = 0;

    this.fontSize = 0;
    this.lineHeight = 0;
    this.spaceWidth = 0;

    // Events
    this.onDraw = this.onDraw.bind(this);
    this.scheduleDraw = this.scheduleDraw.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onReplaceOne = this.onReplaceOne.bind(this);
    this.onShowContextMenu = this.onShowContextMenu.bind(this);
    this.onApplyCorrection = this.onApplyCorrection.bind(this);
    this.onApplyCorrectionAll = this.onApplyCorrectionAll.bind(this);
    this.onAddWordToDictionary = this.onAddWordToDictionary.bind(this);
    this.onIgnoreWordForCorrection = this.onIgnoreWordForCorrection.bind(this);
    this.onIgnoreSuggestForCorrection =
      this.onIgnoreSuggestForCorrection.bind(this);
    this.onOpenSpeakerMenu = this.onOpenSpeakerMenu.bind(this);
    this.onSelectSpeaker = this.onSelectSpeaker.bind(this);
    this.onClickOnBottomToolsBar = this.onClickOnBottomToolsBar.bind(this);
    this.onClickOnWordButtons = this.onClickOnWordButtons.bind(this);

    // Props
    this.forceRedraw = false; // true s'il faut dessiner à nouveau le back canvas;
    this.loaded = false;
    this.continue = false;

    this.subtitle = null;

    this.currentLine = null;
    this.currentWord = null;
    this.currentLetter = null;

    this.currentLineIndex = 0;
    this.currentWordIndex = 0;
    this.currentLetterIndex = 0;

    this.showCptCurs = true;
    this.cptCurs = 0;

    this.underSelection = false; // si c'est le texte est sous sélection
    this.wordsToSelect = []; // les mots en cours de sélection
    this.wordsSelected = []; // Les mots sélectionnés
    this.lettersToSelect = []; // Les lettres en cours de sélection

    this.hasEmptyWord = false;

    this.metricX = 0;
    //this.metricY = 0;
  }

  componentDidMount() {
    this.createResizeObserver();

    this.createOrUpdateProps(true);

    this.continue = true;
    this.loaded = false;

    //requestAnimationFrame(this.onDraw); // on lance le dessin du texte
    this.scheduleDraw();
  }

  createResizeObserver(redraw = true) {
    // on va surveiller automatiquement les changements de taille du foreCanvas......
    const div = document.querySelector('#canvas-' + this.props.subtitle.id); // Sélectionne la div

    // Crée un ResizeObserver
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;

        this.onResize(width, height);

        /*if (redraw) {
          this.onDraw();
        }*/
      }
    });

    // Observer les changements de taille de la div du foreCanvas
    this.resizeObserver.observe(div);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.subtitle.id !== this.props.subtitle.id ||
      !isEqual(prevProps.subtitle, this.props.subtitle)
    ) {
      this.subtitle = this.props.subtitle;
      this.onRefreshCanvas();
      return;
    } 

  /*  if (prevProps.currentSubtitleId !== this.props.currentSubtitleId) {
      this.createOrUpdateProps();
      return;
    }*/

    if (prevProps.active !== this.props.active) {      
      if (this.subtitle.id === this.props.currentSubtitleId) {
        this.createOrUpdateProps();
        return;
      }
    }

    if (
      this.props.showSpeakers &&
      (!isEqual(prevProps.speakers, this.props.speakers) ||
        prevProps.speakers.length !== this.props.speakers.length)
    ) {
      this.onRefreshCanvas();
    }
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
    this.continue = false;
    this.loaded = false;

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = 0;
    }

    this.rafPending = false;
  }

  // ***************************************************************************************
  // createOrUpdateProps() permet d'initialiser ou mettre à jour les propriétés
  // ***************************************************************************************
  createOrUpdateProps(init = false) {
    const { subtitle, currentSubtitleId } = this.props;

    const active = this.props.active && subtitle.id === currentSubtitleId;

    if (init) {
      this.subtitle = subtitle;
    } else {
      this.resetProps(active);
    }

    if(!active){
      // On supprime les lignes vides
      if (
        this.subtitle.lines.some((x) => x.words.length > 0) &&
        this.subtitle.lines.some((x) => x.words.length === 0)
      ) {
        this.subtitle.lines = this.subtitle.lines.filter(
          (x) => x.words.length > 0
        );
      }

      // On supprime les mots vides
      const words = this.getWords();
      if (words.length && words.some((x) => !x.text)) {
        this.subtitle.lines.forEach((line) => {
          line.words = line.words.filter((x) => x.text !== "");
        });
      }
    }

    //const focus = subtitle.focus; // subtitle.id === currentSubtitleId;
    const focus = subtitle.id === currentSubtitleId;

    if (active && this.props.search.showSelection) {
      const { currentPosition, wordsToSearch } = this.props.search;
      this.setPositionOfSearch(currentPosition, wordsToSearch);
    }

    this.setState({
      active,
      focus,
    });

    this.onRefreshCanvas();
  }

  // ***************************************************************************************
  // resetProps() permet de réinitiliser les propriétés
  // ***************************************************************************************
  resetProps(active) {
    if (active) {
      return;
    }

    this.currentLine = null;
    this.currentWord = null;
    this.currentLetter = null;
    this.underSelection = false;
    this.wordsToSelect = [];
    this.wordsSelected = [];
    this.onCloseContextMenu();    
  }

  // ***************************************************************************************
  // onGoToWord() permet d'aller directement au mot
  // ***************************************************************************************
  onGoToWord(indexWord) {
    const words = this.getWords();

    const currentWord = words.find((x) => x.indexWord === indexWord);
    if (currentWord) {
      this.currentLineIndex = currentWord.indexLine;
      this.currentWordIndex = currentWord.index;

      const { letters } = currentWord;
      if (letters.length) {
        this.currentLetterIndex = first(letters).indexLetter;
      } else {
        this.currentLetterIndex = 0;
      }
    }

    this.onRefreshCanvas();
  }

  // ***************************************************************************************
  // onResize() permet de resizer le canvas
  // ***************************************************************************************
  onResize(width, height) {
    if (width === 0 || height === 0) {

    /*     console.warn(
        'subtitle N° ' +
        this.subtitle.id +
        ' : Canvas dimensions are invalid (width or height is 0). Redraw.'
      );
    */

      // on va réinitialiser le canvas
      this.resizeObserver.disconnect();
      this.createResizeObserver(true);
      return;
    }

    if (this.foreCanvas && this.foreCanvas.current) {
      this.foreCanvas.current.width = width;
      this.foreCanvas.current.height = height;

      this.backCanvas.width = width;
      this.backCanvas.height = height;

      this.width = width;
      this.height = height;

      this.forceRedraw = true;
      this.scheduleDraw();
    }
  }

  // ***************************************************************************************
  // processShortcut() appelée par l'application lors de l'appui sur une touche du clavier
  // correspondant à un raccourci.
  // ***************************************************************************************
  processShortcut(key, event) {
    console.log('processShortcut', key);

    // si la transcription est en mode readonly alors on ne doit pas éxécuter ces actions
    if (this.props.readOnly || !this.state.active) {
      return;
    }

    // si on a un mot vide, on le supprime et on refait l'action
    if (this.hasEmptyWord && key !== 'UNDO' && key !== 'REDO') {
      this.removeEmptyWord(key).then(() => this.processShortcut(key));
      return;
    }

    switch (key) {
      case 'SAVE':
        this.onSave();
        break;

      case 'UP':
      case 'DOWN':
      case 'LEFT':
      case 'RIGHT':
        this.onMoveCursorLetterByLetter(key);
        break;

      case 'SELECTLEFT':
      case 'SELECTRIGHT':
      case 'SELECTUP':
      case 'SELECTDOWN':
        this.onSelect(key);
        break;

      case 'SELECTUPSENTENCE':
      case 'SELECTDOWNSENTENCE':
        this.onSelectUpOrDownSentence(key);
        break;
      
      case 'SELECTLETTERBYLETTERONRIGHT':
      case 'SELECTLETTERBYLETTERONLEFT':
        this.onSelectLetterByLetter(key);
        break;
      
      case 'STARTSUBTITLE':
      case 'ENDSUBTITLE':
        this.onGoToStartOrEndOfSubtitle(key);
        break;

      case 'STARTLINE':
      case 'ENDLINE':
        this.onGoToStartOrEndOfLigne(key);
        break;

      case 'STARTWORD':
      case 'ENDWORD':
        this.onGoToStartOrEndOfWord(key);
        break;

      case 'SELECTA':
        this.onSelectWithCtrlA();
        break;

      case 'PREVIOUSWORD':
      case 'NEXTWORD':
        this.onMoveWordByWord(key === 'PREVIOUSWORD');
        break;

      case 'UNSECABLE':
        this.addChar(String.fromCharCode(0xa0));
        break;

      case 'DELETEUNSECABLE':
        this.removeUnsecableSpace();
        break;

      case 'SETDIALOG':
      case 'MOVEUP':
      case 'MOVEDOWN':
      case 'MOVELEFT':
      case 'MOVERIGHT':
      case 'MOVESUBTITLETOLEFT':
      case 'MOVESUBTITLETORIGHT':
      case 'MOVESUBTITLETOCENTER':
        this.onMoveSubtitle(key);
        break;

      case 'BACKSPACE':
         if (this.currentWord?.rtl) {
          this.onBackspaceLeftToRight();
          return;
         }
        
        this.onBackspace();
        break;

      case 'ENTER':
        this.onEnter();
        break;

      case 'DELETE':
        if (this.currentWord?.rtl) {
          this.onDeleteLeftToRight();
          return;
        }

        this.onDelete();
        break;

      case 'DELETEWORD':
        this.onDeleteWord();
        break;

      case 'DELETEWORDSUNTIL':
        this.onDeleteWordsUntil();
        break;

      case 'DELETELINE':
        this.onDeleteLine();
        break;

      case 'BLUE':
      case 'GREEN':
      case 'CYAN':
      case 'RED':
      case 'MAGENTA':
      case 'YELLOW':
      case 'WHITE':
        this.onSetColor(key);
        break;

      case 'CHECKWORD':
      case 'NEWST':
        this.onMarkWord(key);
        break;

      case 'UNDO':
      case 'REDO':
        this.onUndoOrRedo(key);
        break;

      case 'COPY':
        this.onCopy();
        break;

      case 'CUT':
        this.onCut();
        break;

      case 'PASTE':
        this.onPaste();
        break;

      case 'TAB':
        this.onTab();
        break;
      
      case 'ADDHYPHEN':
        this.addHyphen();
        break;

      case 'ADDPERIOD':
      case 'ADDPERIODANDNEWLINE':
        this.addPeriod(key === 'ADDPERIODANDNEWLINE');
        break;

      case 'GROUPBYUNSECABLESPACEWITHNEXTWORD':
      case 'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD':
        this.groupWordsByUnsecableSpace(
          key === 'GROUPBYUNSECABLESPACEWITHNEXTWORD'
        );
        break;

      case 'GROUPWORDSWITHOUTSPACE':
        this.groupWordsWithoutSpace();
        break;

      case 'CONVERSIONTOINITIAL':
      case 'CONVERSIONTOINITIALWITHOUTSPACE':
        this.onConversionToInitial(key === 'CONVERSIONTOINITIAL');
        break;

      case 'UPPERCASEORLOWERCASEONFIRSTLETTER':
      case 'UPPERCASEORLOWERCASEONSECONDLETTER':
      case 'UPPERCASEORLOWERCASEWITHDASH':
      case 'UPPERCASEONWORD':
      case 'LOWERCASEONWORD':
      case 'UPPERCASEORLOWERCASEONSENTENCE':
      case 'UPPERCASEORLOWERCASEWITHAPOSTROPHEORPERIOD':
        this.onUpperOrLowerCase(key);
        break;

      case 'RETURNTOLINEWITHHYPHEN':
        this.onReturnToLineWithHypen();
        break;

      case 'ADDQUOTES':
        this.addQuotes();
        break;

      case 'ADDTWOAPOSTROPHES':
      case 'ADDONEAPOSTROPHE':
        this.addApostrophes(key === 'ADDONEAPOSTROPHE');
        break;

      case 'ADDORREMOVESLETTER':
      case 'ADDORREMOVENTLETTER':
        this.addOrRemoveLetter(key);
        break;

      case 'INVERTPERIODEANDCOMMA':
        this.invertPeriodAndComma();
        break;

      case 'INVERTA':
        this.invertALetter();
        break;

      case 'HYPHENATETWOWORDS':
        this.hyphenateTwoWords();
        break;

      case 'REPLACEHYPHENWITHSPACE':
      case 'REPLACEHYPHENWITHUNSECABLESPACE':
        this.replaceHyphenate(key === 'REPLACEHYPHENWITHUNSECABLESPACE');
        break;

      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_C':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_D':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_J':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_L':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_M':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_N':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_Q':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_S':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_T':
        this.addOrRemoveLetterWithApostrophe(key);
        break;

      case 'ADDORREMOVEAPOSTROPHETOLETTER_C':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_D':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_J':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_L':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_M':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_N':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_Q':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_S':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_T':
        this.addOrRemoveApostropheToLetter(key);
        break;

      case 'REPLACE_E':
      case 'REPLACE_Z':
      case 'REPLACE_R':
      case 'REPLACE_T':
        this.replaceLetter(key);
        break;

      case 'ADDORREMOVELETOWORD':
        this.addOrRemoveLeToWord();
        break;

      case 'TAKEWORDFROMLASTSUBTITLETOCURRENTSUBTITLE':
      case 'TAKEWORDFROMNEXTSUBTITLETOCURRENTSUBTITLE':
      case 'TAKEWORDFROMCURRENTSUBTITLETOPREVSUBTITLE':
      case 'TAKEWORDFROMCURRENTSUBTITLETONEXTSUBTITLE':

        
        this.onTakeWordToSubtitle(key, event.shiftKey);
        break;

      case 'TAKEIN':
      case 'TAKEOUT':
      case 'TAKETIMECODEVIDEOTOINSUBTITLE':
      case 'TAKETIMECODEVIDEOTOOUTSUBTITLE':
        
        this.onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle(key);
        break;

      case 'TAKETIMECODEOUTFROMPREVSUBTITLETOINCURRENTSUBTITLE':
      case 'TAKETIMECODEINFROMNEXTSUBTITLETOOUTCURRENTSUBTITLE':
        this.onTakeTimeCodeToSubtitle(key);
        break;

      case 'CUTASUBTITLE':
        this.onCutSubtitle();
        break;

      case 'REGROUPSUBTITLE':
        this.onRegroupSubtitle();
        break;

      case 'ROTATEWORDTOUP':
      case 'ROTATEWORDTODOWN':
        this.onRotateWord(key);
        break;

      case "CHANGELINEHEIGHT":
        this.onChangeLineHeight();
        break;

      case "TOPREVIOUSSUBTITLE":
      case "TONEXTSUBTITLE":
      case "TOPREVIOUSLINE":
      case "TONEXTLINE":
        this.onClickOnWordButtons(key, event.shiftKey);
        break;

      default:
        return false;
    }

    return true;
  }

  processShortcutOverride(key) {
  
    switch(key){
      case 'CUTASUBTITLE':
        this.onCutSubtitle();
        break;

      case 'REGROUPSUBTITLE':
        this.onRegroupSubtitle();
        break;
      
      case 'TAKEWORDFROMLASTSUBTITLETOCURRENTSUBTITLE':
      case 'TAKEWORDFROMNEXTSUBTITLETOCURRENTSUBTITLE':
      case 'TAKEWORDFROMCURRENTSUBTITLETOPREVSUBTITLE':
      case 'TAKEWORDFROMCURRENTSUBTITLETONEXTSUBTITLE':
        this.onTakeWordToSubtitle(key);
      break;

      default:
        return;
    }
  }

  scheduleDraw() {
    if (this.rafPending) {
      return;
    }

    this.rafPending = true;
    this.rafId = requestAnimationFrame(() => {
      this.rafPending = false;
      this.onDraw();
    });
  }

  onDraw() {
    if (!this.foreCanvas || !this.foreCanvas.current) {
      return;
    }

    if (this.forceRedraw && this.subtitle) {
      // Vérifiez que les dimensions du canvas sont valides
      if (this.backCanvas.width === 0 || this.backCanvas.height === 0) {
        console.warn('Canvas dimensions are invalid (width or height is 0). Redraw.');

        // on va réinitialiser le canvas
        this.resizeObserver.disconnect();
        this.createResizeObserver(true);

        return;
      }

      this.drawCanvas();

      const {
        marginLeft: dMarginLeft,
        borderColor
      } = this.props.displayParameters;

      const { teletext, boxing, fontName } = this.props.subtitleParameters;

      const marginLeft = (parseFloat(dMarginLeft) / 100) * this.width;

      this.metricX = marginLeft;

      let currentY = this.height;

      let indexWord = 0;

      this.subtitle.lines.forEach((line, index) => {
        line.index = index;

        line.words.forEach((w, i) => {
          w.index = i;
          w.indexLine = line.index;
          w.indexWord = indexWord;
          indexWord++;
        });
      });

      let lines = reverse([...this.subtitle.lines]);

      if (!this.state.focus) {
        lines = lines.filter((x) => x.words.length);
      }

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        const { words } = line;

        const sentence = join(
          words.map((x) => x.text),
          ' '
        );

        this.backCtx.font = `${this.fontSize}px ${teletext ? "Courier New" : fontName}`;

        this.spaceWidth = this.backCtx.measureText(' ').width;
        const textWidth = this.backCtx.measureText(sentence).width;

        line.width = textWidth;

        let startX = this.getCoordinateX(line);

        line.startX = startX;
        line.startY = currentY;

        // Dessiner le rectangle
        if ((teletext || boxing) && words.length) {
          this.drawBoxing(this.backCtx, startX, currentY, textWidth);
        }

        let indexLetter = 0;

        for (let j = 0; j < words.length; j++) {
          const word = line.words[j];

          const metricsWord = this.backCtx.measureText(word.text);

          word.width = metricsWord.width + this.spaceWidth;
          word.height =
            metricsWord.actualBoundingBoxAscent +
            metricsWord.actualBoundingBoxDescent;

          const startY = currentY - this.lineHeight / 2;

          word.startX = startX;
          word.endX = startX + word.width;
          word.startY = startY;
          word.endY = startY + this.lineHeight;

          indexLetter = this.createLettersForWord(
            word,
            startX,
            startY,
            indexLetter
          );

          // dessiner la bordure
          if (!teletext && !boxing) {
            this.backCtx.strokeStyle = borderColor;
            this.backCtx.lineWidth = 3.5;
            this.backCtx.strokeText(word.text, word.startX, word.startY, word.width);
          }

          // dessiner la recherche
          if (
            (this.props.search.showSearch || this.props.filtered) &&
            this.props.search.wordsToSearch.length
          ) {
            const wordsFounded = this.props.search.wordsToSearch.filter(
              (x) => x.id === this.subtitle.id
            );

            if (wordsFounded.length > 0) {
              wordsFounded.forEach((wordFounded) => {
                const wordToSearch = wordFounded.words.find(
                  (x) =>
                    x.indexWord === word.indexWord &&
                    x.inWord === word.in &&
                    x.text === word.text
                );

                if (wordToSearch) {
                  this.drawSearchWord(
                    this.backCtx,
                    word,
                    wordToSearch.startIndex,
                    wordToSearch.endIndex
                  );
                }
              });
            }
          }

          // dessiner la sélection
          if (this.underSelection) {
            if (this.wordsToSelect &&
              this.wordsToSelect.length &&
                this.wordsToSelect.some(
                  (w) =>
                    w !== null &&
                    w.index === word.index &&
                    w.indexWord === word.indexWord &&
                    w.indexLine === word.indexLine &&
                    w.text === word.text
                )
            ) {
              this.drawSelectionWord(this.backCtx, word);
            }

            if (this.lettersToSelect && this.lettersToSelect.length) {
              const letters = this.lettersToSelect.filter(
                (x) =>
                  x.indexWord === word.index && x.indexLine === word.indexLine
              );

              if (letters.length) {
                letters.forEach((l) => {
                  this.drawSelectionLetter(this.backCtx, l);
                });
              }
            }
          }

          if (word.suggest) {
            this.drawSuggestErrors(this.backCtx, word);
          }

          // dessiner le mot
          this.drawWord(this.backCtx, word);

          startX += word.width;
          indexWord--;
        }

        currentY -= this.lineHeight;
      }

      if (this.subtitle.mark) {
        const firstLine = first(this.subtitle.lines);
        if (firstLine.words.length) {
          this.drawMarkWords(
            this.backCtx,
            this.subtitle.mark,
            firstLine.startX,
            firstLine.startY
          );
        }
      }

      this.forceRedraw = false;

      if (!this.loaded) {
        this.loaded = true;
      }
    }

    this.foreCtx = this.foreCanvas.current.getContext('2d');
    this.foreCtx.drawImage(this.backCanvas, 0, 0);

    if (this.state.active) {
      this.createCursor();
    }    
  }

  createLettersForWord(word, x, y, indexLetter) {
    const letters = [];
    const text = word.text;

    if (text.length === 0) {
      indexLetter++;
      word.letters = [];
      return indexLetter;
    }

    for (let i = 0; i < text.length; i++) {
      const char = text.charAt(i);

      const metricsLetter = this.backCtx.measureText(char);
      const letter = {
        index: i,
        letter: char,
        width: metricsLetter.width,
        x: x,
        y: y,
        indexLetter,
        indexWord: word.index,
        indexLine: word.indexLine,
        lastChar: false,
      };

      if (i !== 0) {
        const lastLetter = letters[i - 1];
        letter.x = lastLetter.width + lastLetter.x;
      }

      letters.push(letter);
      indexLetter++;
    }

    const space = {
      index: letters.length,
      letter: ' ',
      width: this.spaceWidth,
      x: x,
      y: y,
      indexLetter,
      indexWord: word.index,
      indexLine: word.indexLine,
      lastChar: true,
    };

    if (letters.length === 0) {
      space.x = x;
    } else {
      const lastLetterOfWord = letters[letters.length - 1];
      space.x = lastLetterOfWord.width + lastLetterOfWord.x;
    }

    letters.push(space);
    indexLetter++;

    word.letters = letters;

    return indexLetter;
  }

  // ***************************************************************************************
  // onRefreshCanvas() permet de rafraichir le canvas
  // ***************************************************************************************
  onRefreshCanvas() {
    // On réinitialise le canvas
    this.onResize(this.width, this.height);

    this.cptCurs = 0; // on force l'affichage du curseur clignotant

    // On force le dessin
    this.forceRedraw = true;

    this.scheduleDraw();
  }

  // ***************************************************************************************
  // onMove() Cette fonction doit être appelée à chaque fois que le curseur change de mot
  // ***************************************************************************************
  onMove() {    
    // on doit rafraichir le canvas car comme le fond est transparent, on doit le recréer
    this.onRefreshCanvas();

    if (!this.subtitle || !this.subtitle.lines) {
      return;
    }

    const words = this.getWords();
    if (!words.length) {
      this.props.onMove(this.subtitle.id, this.subtitle.in);
      return;
    }

    const currentLine = this.subtitle.lines[this.currentLineIndex];
    if (!currentLine) {
      return;
    }

    const currentWord = currentLine.words[this.currentWordIndex];
    if (!currentWord) {
      return;
    }

    this.props.onMove(this.subtitle.id, currentWord.in ?? this.subtitle.in);
  }

  // ***************************************************************************************
  // onChange() Cette fonction doit être appelée à chaque fois que le script est modifié
  // ***************************************************************************************
  onChange() {
    this.subtitle.len = this.getNbChars();

    this.subtitle.lines.forEach((line) => {
      line.len = this.getSentence(line).length;
    });

    const subtitleCloned = cloneSubtitle(this.subtitle);
    subtitleCloned.lisibility = getLisibility(
      subtitleCloned,
      this.props.subtitleParameters
    );
    this.props.onChange(subtitleCloned);
    this.onRefreshCanvas();
  }

    // ***************************************************************************************
  // setCurrentPositionOnLetter() 
  // Cette fonction est appelée pour mettre le curseur sur les bonnes positions de ligne, mot et lettre
  // ***************************************************************************************
  setCurrentPositionOnLetter(value) {
    const { currentLineIndex, currentWordIndex, currentLetterIndex } = value;

    this.currentLineIndex = currentLineIndex;
    this.currentWordIndex = currentWordIndex;
    this.currentLetterIndex = currentLetterIndex;

    this.currentLine = this.subtitle.lines[currentLineIndex];
    this.currentWord = this.currentLine.words[currentWordIndex];
    this.currentLetter = this.currentWord.letters.find(
      (x) => x.indexLetter === currentLetterIndex
    );
  }

  // ***************************************************************************************
  // onSave() Cette fonction est appelée quand on appelle le raccourci SAVE
  // ***************************************************************************************
  onSave() {
    this.props.onSave();
  }

  onClickOnBottomToolsBar(toolbar) {

    switch(toolbar.type) {
      case "color":
        this.onSetColor(toolbar.value)
        break;
      
      case "align":
        this.onMoveSubtitle(toolbar.value);
        break;

      default:
        return;
    }

  }

  onClickOnWordButtons(key, shiftKeyPressed) {

    switch (key)
    {
      case "TOPREVIOUSSUBTITLE":
        this.onMoveWordToPreviousSubtitle(shiftKeyPressed);
        break;
      
      case "TONEXTSUBTITLE":
        this.onMoveWordToNextSubtitle(shiftKeyPressed);
        break;
      
      case "TOPREVIOUSLINE":
        this.onMoveWordToPreviousLine();
        break;
      
      case "TONEXTLINE":
        this.onMoveWordToNextLine();
        break;

      default:
        return;
    }
  }

  getTimecodeIn(backcolor) {
    return this.RenderTimeCode(this.props.subtitle.in, backcolor, false);
  }

  getTimecodeOut(backcolor) {
    return this.RenderTimeCode(this.props.subtitle.out, backcolor, true);
  }

  getDuration() {
  
    return (
      <span className="white">
        {this.props.getIntervalString(
          this.props.subtitle.in,
          this.props.subtitle.out
        )}
      </span>
    );
    
  }

  RenderTimeCode(currentTime, backcolor, outTime) {
    const classnames = [];
    if (backcolor) {
      classnames.push(`timecode-${backcolor}`);
    }

    if (
      this.props.timecode &&
      this.props.timecode.isTyping &&
      this.props.timecode.isTimeCodeOut === outTime &&
      this.props.timecode.newTimeCodeString &&
      this.subtitle.id === this.props.currentSubtitleId
    ) {
      //classnames.push('typing');

      const classnamesString = classnames.join(' ');
      return (
        <span className={classnamesString}>
          {this.props.timecode.newTimeCodeString}
        </span>
      );
    }

    const classnamesString = classnames.join(' ');

    return (
      <span className={classnamesString}>
        {this.props.getTimeCodeString(currentTime)}
      </span>
    );

  }

  getIcons(icons) {
     if (!icons) {
      return <></>;
     }
    
    const lang = this.context.language;

    const tooltips = [];

    icons.forEach((icon, index) => {
      tooltips.push(
        <Tooltip text={lang === 'fr' ? icon.fr : icon.en} key={'tooltip-' + index}>
          <Icon
            image={icon.img}
            width="20"
            height="20"
            nochangecolor="true"
          ></Icon>
        </Tooltip>
      );
    });

    return tooltips;
  }

   getIntervalleIn(backcolor) {
    const { subtitles } = this.props;
    if (!subtitles.length || !this.subtitle) {
      return <></>;
    }

    const currentIndex = subtitles.findIndex((x) => x.id === this.subtitle.id);

    const prevSubtitle = subtitles[currentIndex - 1];
     const firstDelay = this.props.getIntervalString(
       prevSubtitle ? prevSubtitle.out : 0,
       this.props.subtitle.in
     );

    return (
      <span className={'small' + (backcolor ? ` intervalle-${backcolor}` : '')}>
        {firstDelay}
      </span>
    );
  }

  getIntervalleOut(backcolor) {
    const { subtitles } = this.props;
    if (!subtitles.length || !this.subtitle) {
      return <></>;
    }

    const currentIndex = subtitles.findIndex((x) => x.id === this.subtitle.id);


    const nextSubtitle = subtitles[currentIndex + 1];
    const secondDelay = this.props.getIntervalString(
          this.props.subtitle.out,
          nextSubtitle ? nextSubtitle.in : 0
        )
    
    return (
      <span className={'small' + (backcolor ? ` intervalle-${backcolor}` : '')}>
        {secondDelay}
      </span>
    );
  }

  getSpeakers() {
  const { showSpeakers, speakers, subtitle } = this.props;

  if (!showSpeakers || !speakers.length || !subtitle?.lines?.length) {
    return null;
  }

  return subtitle.lines.map((line, indexLine) => {
    const speaker = speakers.find(
      (x) => x.id === line.speakerId
    );

    return this.getSpeaker(speaker, indexLine);
  });
}

  getSpeaker(speaker, indexLine) {
    const names = [];

    if (speaker) {
      if (speaker.firstname) {
        names.push(speaker.firstname);
      }

      if (speaker.name) {
        names.push(speaker.name);
      }
    }

    const name = names.length ? names.join(' ') : '...';
    const initial = names.length ? names.map((str) => str[0]) : '...';
    const color = this.state.speakerMenu.display &&
        indexLine === this.state.speakerMenu.indexLine
      ? '#FF8282'
      : speaker && speaker.color
      ? getColorByShortcut(speaker.color).hex
      : '#CCCCCC';

    return (
      <button
        key={`button-${this.props.subtitle.id}-${indexLine}`}
        type="button"
        title={name}
        disabled={this.props.readOnly}
        style={{
            width: "17px",
            height: "17px",
            borderRadius: "50%",
            backgroundColor: color,
            border: "1px solid rgba(255,255,255,0.4)",
            color: "gray",
            fontSize: "11px",
            fontWeight: "bold",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            outline: "none",
            boxSizing: "border-box",
            position: "relative",
            top: "1px",
          }}



        onClick={(event) => this.onOpenSpeakerMenu(event, speaker?.id, indexLine)}
      >
        <span>{initial}</span>
      </button>
    );
  }

    getSelectionLines() {
    if (!this.subtitle || !this.subtitle.lines || this.props.readOnly) {
      return <></>;
    }

    return this.props.subtitle.lines.map((line, index) => {

      if (line.len === 0){
        return;
      }

      const label = `chk-${this.props.subtitle.id}-line-${index}`;

      return (
        <div className='group'>
          <SelectionCheckbox
            key={label}
            id={label}
            selected={line.selected}
            srText={`Sélectionner la ligne ${index + 1} du sous-titre ${this.props.subtitle.id + 1}`}
            onChange={(selected) => this.props.onSubtitleLineChecked(this.props.subtitle.id, index, selected)}
          />
        </div>
      );
    });
  }

  render() {
    const errorInfo = getSubtitleErrorsInfos(this.subtitle);

    // 2 lignes par défaut
    const nbLignes = this.props.subtitleParameters.numberOfLines - 2;

    const cardSubtitleHeight = 120 + 25 * nbLignes;
    const cardSubtitleCanvasHeight = 65 + 25 * nbLignes;


    var bottomToolsBar = (<></>);
    if ((!this.props.readOnly) && (this.props.applicationsparams.subtitling.displaySubToolsBar))
      bottomToolsBar = (
        <div style = {{height:"18px", display:"flex", paddingRight:"20px", justifyContent:"flex-end", width:"100%"}}>
          <TextToolbar onClickOnBottomToolsBar={this.onClickOnBottomToolsBar} />
        </div>
    )
    
    var wordButtons = (<></>);
    if ((!this.props.readOnly) && (this.props.applicationsparams.subtitling.displayWordsButtons))
      wordButtons = (
          <>
          {/* Bouton Coin Supérieur Gauche */}
          <SimpleButton onClick={this.onClickOnWordButtons} name = "TOPREVIOUSSUBTITLE" top={4} left={4} image ={imgUpWord} size = {14} />

          {/* Bouton Coin Supérieur Droit */}
          <SimpleButton onClick = {this.onClickOnWordButtons} name = "TONEXTLINE" top={4} right={4} image ={imgDownWord} size = {14} />

          {/* Bouton Coin Inférieur Gauche */}
          <SimpleButton onClick = {this.onClickOnWordButtons} name = "TOPREVIOUSLINE" bottom={4} left={4} image ={imgUpWord} size = {14} />

          {/* Bouton Coin Inférieur Droit */}
          <SimpleButton onClick = {this.onClickOnWordButtons} name = "TONEXTSUBTITLE" bottom={4} right={4} image ={imgDownWord} size = {14} />
          </>
)


    // <div style={{backgroundColor:"blue", height:"18px"}}>ICI PEUT ETRE</div>

    return (
      <div
        className={
          'card-subtitle' +
          (this.state.focus ? ' active' : '') +
          (errorInfo && errorInfo.textBackcolor
            ? ` text-${errorInfo.textBackcolor}`
            : '')
        }
        style={{ height: cardSubtitleHeight + 'px' }}
      >
        <div className="card-subtitle-top">
          <div className="col-1">
            <div className="row">
              <div
                className={'checkbox' + (this.props.readOnly ? ' hide' : '')}
              >
                <SelectionCheckbox
                  key={`chk-${this.props.subtitle.id}`}
                  id={`chk-${this.props.subtitle.id}`}
                  selected={this.props.subtitle.selected}
                  srText={`Sélectionner le sous-titre ${this.props.subtitle.id + 1}`}
                  onChange={(selected) =>
                    this.props.onSubtitleChecked(
                      this.props.subtitle.id,
                      selected
                    )
                  }
                ></SelectionCheckbox>
              </div>
            </div>
            <div className="row">
              <span
                className="subtitle-number"
              >
                {this.props.subtitle.id + 1}
              </span>
            </div>
          </div>
          <div className="col left">
            <div className="row intervalles">
              {this.getIntervalleIn(errorInfo?.interbeforeBackcolor)}
            </div>
            <div className={
                'row timecode' +
                (this.props.timecode.isTyping &&
                !this.props.timecode.isTimeCodeOut &&
                this.state.focus
                  ? ' typing'
                  : '')
              }>
              {this.getTimecodeIn(errorInfo?.tcinBackcolor)}
            </div>
          </div>
          <div className="col center">
            <div className="row icons">{this.getIcons(errorInfo?.icons)}</div>
            <div className="row timecode">{this.getDuration()}</div>
          </div>
          <div className="col lisibility">
            <Lisibility 
              ref={this.lisibilityRef}
              stparams={this.props.subtitleParameters}
              subtitle={this.props.subtitle}
            />
          </div>
          <div className="col right">
            <div className="row intervalles">
              {this.getIntervalleOut(errorInfo?.interafterBackcolor)}
            </div>
            <div className={
                'row timecode' +
                (this.props.timecode.isTyping &&
                this.props.timecode.isTimeCodeOut &&
                this.state.focus
                  ? ' typing'
                  : '')
              }>
              {this.getTimecodeOut(errorInfo?.tcoutBackcolor)}
            </div>
          </div>
        </div>
        <div
          className="card-subtitle-canvas"
          id={'canvas-' + this.props.subtitle.id}
          style={{
            zIndex: this.props.zIndex,
            height: cardSubtitleCanvasHeight + 'px',
          }}
          onDoubleClick={this.onDoubleClick}
          onClick={this.onClick}
          onMouseUp={this.onMouseUp}
          onMouseDown={this.onMouseDown}
          onMouseMove={this.onMouseMove}
        >
          
          <div className="column">
            <div className="selection">{this.getSelectionLines()}</div>
            <div className="speaker">{this.getSpeakers()}</div>
          </div>
          <div style = {{position: 'relative', width:"100%", margin:0}}>
            <canvas
              className="foreCanvas"
              ref={this.foreCanvas}
              onContextMenu={this.onShowContextMenu}
            ></canvas>
            {wordButtons}
          </div>

           <div className="length">
            {this.props.subtitle?.lines.map((line, index) => {
              const maxLength = this.getMaxLength(line);
              return (
                <p
                  className={line.len > maxLength ? 'error' : ''}
                  key={'len' + index}
                >
                  {line.len}
                </p>
              );
            })}
          </div>
          
        </div>
        {bottomToolsBar}
        <ContextMenu
          ref={this.contextMenuRef}
          contextMenu={this.state.contextMenu}
          onApplyCorrection={this.onApplyCorrection}
          onApplyCorrectionAll={this.onApplyCorrectionAll}
          onAddWordToDictionary={this.onAddWordToDictionary}
          onIgnoreWordForCorrection={this.onIgnoreWordForCorrection}
          onIgnoreSuggestForCorrection={this.onIgnoreSuggestForCorrection}
          subtitles={this.props.subtitles}
        ></ContextMenu>
         <SpeakerMenu
          ref={this.speakerMenuRef}
          speakerMenu={this.state.speakerMenu}
          speakers={this.props.speakers}
          onSelectSpeaker={this.onSelectSpeaker}
          onClose={() => this.onCloseSpeakerMenu()}
        />
      </div>
    );
  }
}

// Set cursor
Subtitle.prototype.onMoveCursorLetterByLetter = onMoveCursorLetterByLetter;
Subtitle.prototype.onMoveCursorToLeft = onMoveCursorToLeft;
Subtitle.prototype.onMoveCursorToRight = onMoveCursorToRight;
Subtitle.prototype.onMoveCursorToDown = onMoveCursorToDown;
Subtitle.prototype.onMoveCursorToUp = onMoveCursorToUp;
Subtitle.prototype.onMoveWordByWord = onMoveWordByWord;
Subtitle.prototype.onGoToStartOrEndOfSubtitle = onGoToStartOrEndOfSubtitle;
Subtitle.prototype.onGoToStartOrEndOfLigne = onGoToStartOrEndOfLigne;
Subtitle.prototype.onGoToStartOrEndOfWord = onGoToStartOrEndOfWord;


// Move
Subtitle.prototype.onSetDialog = onSetDialog;
Subtitle.prototype.onMoveSubtitle = onMoveSubtitle;
Subtitle.prototype.onMoveSubtitleToUp = onMoveSubtitleToUp;
Subtitle.prototype.onMoveSubtitleToDown = onMoveSubtitleToDown;
Subtitle.prototype.onMoveSubtitleToLeft = onMoveSubtitleToLeft;
Subtitle.prototype.onMoveSubtitleToRight = onMoveSubtitleToRight;
Subtitle.prototype.onMoveSubtitleTo = onMoveSubtitleTo;
Subtitle.prototype.onRotateWord = onRotateWord;
Subtitle.prototype.onRotateWordToUp = onRotateWordToUp;
Subtitle.prototype.onRotateWordToDown = onRotateWordToDown;
Subtitle.prototype.onMoveLineToUp = onMoveLineToUp;
Subtitle.prototype.onMoveLineToDown = onMoveLineToDown;

// Mouse
Subtitle.prototype.onDoubleClick = onDoubleClick;
Subtitle.prototype.onMouseMove = onMouseMove;
Subtitle.prototype.onMouseUp = onMouseUp;
Subtitle.prototype.onMouseDown = onMouseDown;
Subtitle.prototype.onClick = onClick;

// Keyboard
Subtitle.prototype.onSelect = onSelect;
Subtitle.prototype.onSelectLeftOrRight = onSelectLeftOrRight;
Subtitle.prototype.onSelectTopOrBottom = onSelectTopOrBottom;
Subtitle.prototype.onBackspace = onBackspace;
Subtitle.prototype.onBackspaceLeftToRight = onBackspaceLeftToRight;
Subtitle.prototype.onDelete = onDelete;
Subtitle.prototype.onDeleteLeftToRight = onDeleteLeftToRight;
Subtitle.prototype.onDeleteWord = onDeleteWord;
Subtitle.prototype.onDeleteWordsUntil = onDeleteWordsUntil;
Subtitle.prototype.onDeleteLine = onDeleteLine;
Subtitle.prototype.onEnter = onEnter;
Subtitle.prototype.onDeleteSelection = onDeleteSelection;
Subtitle.prototype.onSetColor = onSetColor;
Subtitle.prototype.onSelectWithCtrlA = onSelectWithCtrlA;
Subtitle.prototype.onMarkWord = onMarkWord;
Subtitle.prototype.onCopy = onCopy;
Subtitle.prototype.onCut = onCut;
Subtitle.prototype.onPaste = onPaste;
Subtitle.prototype.onTab = onTab;
Subtitle.prototype.onSelectUpOrDownSentence = onSelectUpOrDownSentence;
Subtitle.prototype.onTakeWordToSubtitle = onTakeWordToSubtitle;
Subtitle.prototype.onTakeWordFromLastSubtitleToCurrentSubtitle =
  onTakeWordFromLastSubtitleToCurrentSubtitle;
Subtitle.prototype.onTakeWordFromNextSubtitleToCurrentSubtitle =
  onTakeWordFromNextSubtitleToCurrentSubtitle;
Subtitle.prototype.onTakeWordFromCurrentSubtitleToPrevSubtitle =
  onTakeWordFromCurrentSubtitleToPrevSubtitle;
Subtitle.prototype.onTakeWordFromCurrentSubtitleToNextSubtitle =
  onTakeWordFromCurrentSubtitleToNextSubtitle;
Subtitle.prototype.onCutSubtitle = onCutSubtitle;
Subtitle.prototype.onRegroupSubtitle = onRegroupSubtitle;
Subtitle.prototype.onSelectLetterByLetter = onSelectLetterByLetter;
Subtitle.prototype.onChangeLineHeight = onChangeLineHeight;
Subtitle.prototype.onMoveWordToPreviousSubtitle = onMoveWordToPreviousSubtitle;
Subtitle.prototype.onMoveWordToNextSubtitle = onMoveWordToNextSubtitle;
Subtitle.prototype.onMoveWordToPreviousLine = onMoveWordToPreviousLine;
Subtitle.prototype.onMoveWordToNextLine = onMoveWordToNextLine;

// Char
Subtitle.prototype.addChar = addChar;
Subtitle.prototype.addCommonChar = addCommonChar;
Subtitle.prototype.addHebrewOrArabicChar = addHebrewOrArabicChar;
Subtitle.prototype.addCommonHebrewOrArabicChar = addCommonHebrewOrArabicChar;
Subtitle.prototype.addSpace = addSpace;
Subtitle.prototype.addHyphen = addHyphen;
Subtitle.prototype.addPeriod = addPeriod;
Subtitle.prototype.groupWordsByUnsecableSpace = groupWordsByUnsecableSpace;
Subtitle.prototype.groupWordsWithoutSpace = groupWordsWithoutSpace;
Subtitle.prototype.onConversionToInitial = onConversionToInitial;
Subtitle.prototype.onUpperOrLowerCase = onUpperOrLowerCase;
Subtitle.prototype.onReturnToLineWithHypen = onReturnToLineWithHypen;
Subtitle.prototype.removeUnsecableSpace = removeUnsecableSpace;
Subtitle.prototype.addQuotes = addQuotes;
Subtitle.prototype.addApostrophes = addApostrophes;
Subtitle.prototype.addOrRemoveLetter = addOrRemoveLetter;
Subtitle.prototype.invertPeriodAndComma = invertPeriodAndComma;
Subtitle.prototype.invertALetter = invertALetter;
Subtitle.prototype.hyphenateTwoWords = hyphenateTwoWords;
Subtitle.prototype.replaceHyphenate = replaceHyphenate;
Subtitle.prototype.addOrRemoveLetterWithApostrophe =
  addOrRemoveLetterWithApostrophe;
Subtitle.prototype.addOrRemoveApostropheToLetter =
  addOrRemoveApostropheToLetter;
Subtitle.prototype.replaceLetter = replaceLetter;
Subtitle.prototype.addOrRemoveLeToWord = addOrRemoveLeToWord;

// Undo/Redo
Subtitle.prototype.addNewActionForUndo = addNewActionForUndo;
Subtitle.prototype.onUndoOrRedo = onUndoOrRedo;
Subtitle.prototype.updateSubtitleAfterUndoOrRedo =
  updateSubtitleAfterUndoOrRedo;
Subtitle.prototype.cancelUndo = cancelUndo;
Subtitle.prototype.addSubtitlesToUndoOrRedo = addSubtitlesToUndoOrRedo;

// Time code
Subtitle.prototype.onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle =
  onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle;
Subtitle.prototype.onTakeTimeCodeToSubtitle = onTakeTimeCodeToSubtitle;
Subtitle.prototype.onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle =
  onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle;
Subtitle.prototype.onTakeTimeCodeFromNextSubtitleToCurrentSubtitle =
  onTakeTimeCodeFromNextSubtitleToCurrentSubtitle;

// Corrector
Subtitle.prototype.onCloseContextMenu = onCloseContextMenu;
Subtitle.prototype.onShowContextMenu = onShowContextMenu;
Subtitle.prototype.onApplyCorrection = onApplyCorrection;
Subtitle.prototype.onApplyCorrectionForSpelling = onApplyCorrectionForSpelling;
Subtitle.prototype.onApplyCorrectionForGrammar = onApplyCorrectionForGrammar;
Subtitle.prototype.onApplyCorrectionForSpellingEnglish =
  onApplyCorrectionForSpellingEnglish;
Subtitle.prototype.onApplyCorrectionAll = onApplyCorrectionAll;
Subtitle.prototype.onAddWordToDictionary = onAddWordToDictionary;
Subtitle.prototype.onIgnoreWordForCorrection = onIgnoreWordForCorrection;
Subtitle.prototype.onIgnoreSuggestForCorrection = onIgnoreSuggestForCorrection;

// Speaker
Subtitle.prototype.onOpenSpeakerMenu = onOpenSpeakerMenu;
Subtitle.prototype.onCloseSpeakerMenu = onCloseSpeakerMenu;
Subtitle.prototype.onSelectSpeaker = onSelectSpeaker;

Subtitle.defaultProps = {
  active: false,
  readOnly: false,
  bottomToolsBar: false,
  wordsButton: false,
  showSpeakers: true,
  speakers: [],
  timecode: {
    isTyping: false,
    isTimeCodeOut: false,
    newTimeCodeString: null,
    value: null,
  },
  applicationsparams:
  {
    subtitling:
    {
      displaySubToolsBar: false,
      displayWordsButtons: false,
    }
  }
};

export default Subtitle;
